import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
// import Presentation from '../Pages/Presentation';
import UserContext from './Contexts/UserContext';
import Landing from '../Pages/Landing';
import Home from '../Pages/Home';
import RoomPlaceholder from '../Pages/PresentationRoom';
import ForgotPassword from '../Pages/ForgotPassword';
import ResetPassword from '../Pages/ResetPassword';
import GuestLanding from '../Pages/GuestLanding';
import Help from '../Pages/Help';

const loggedInRoutes = () => (
    <RouterRoutes>
        <Route path='/home' element={<Home />} />
        <Route path='/presentation/:roomId' element={<RoomPlaceholder />} />
        <Route path='/watch/:roomUrl' element={<GuestLanding />} />
        <Route path='/help' element={<Help />} />
        <Route path='*' element={<Navigate to='/home' replace />} />
    </RouterRoutes>
);

const loggedOutRoutes = () => (
    <RouterRoutes>
        <Route path='/welcome' element={<Landing />} />
        <Route path='/presentation/:roomId' element={<Landing />} />
        <Route path='/watch/:roomUrl' element={<GuestLanding />} />
        <Route path='/help' element={<Help />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route path='*' element={<Navigate to='/welcome?redirect=true' replace />} />
    </RouterRoutes>
);

const Routes = () => (
    <UserContext.Consumer>
        {(user) => (user.userId ? loggedInRoutes() : loggedOutRoutes())}
    </UserContext.Consumer>
);

export default Routes;
